import { render, staticRenderFns } from "./DashHeader.vue?vue&type=template&id=65c0e2e6&"
import script from "./DashHeader.vue?vue&type=script&lang=ts&"
export * from "./DashHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports